import { FACE_BY_ID } from "~/lib/faces";
import { useFaceSeo } from "~/lib/seo/useSeo";
import { PaginaDisciplina } from "~/ui/PaginaDisciplina";

export function AI() {
  const face = FACE_BY_ID.ai;
  useFaceSeo(face);

  return (
    <PaginaDisciplina
      rotulo="Inteligência artificial"
      titulo="Modelo de linguagem dentro de produto que roda."
      intro="Integração com Claude e OpenAI, busca em documento próprio, uso de ferramentas, laços de agente e conversa em tempo real. Mais a camada de automação que liga isso ao resto da sua operação."
      entrego={[
        {
          titulo: "Aplicação com modelo de linguagem",
          corpo: "Integração, busca nos seus documentos antes de responder, uso de ferramentas e resposta em tempo real.",
        },
        {
          titulo: "Automação com n8n",
          corpo: "Entrada por webhook, chamada ao modelo, decisão em vários passos e ação de saída. Hospedado por você ou na nuvem do n8n.",
        },
        {
          titulo: "Disparo e resposta automática",
          corpo: "Sequências, campanhas e respostas por e-mail, WhatsApp, Telegram ou Slack, a partir de um fluxo só.",
        },
        {
          titulo: "Resposta a evento e CRM",
          corpo: "Contato chega, é enriquecido, marcado, respondido pelo canal certo e registrado. O modelo entra onde é preciso julgar.",
        },
      ]}
      nota="Uma ressalva que eu faço antes de qualquer proposta: modelo de linguagem erra, inventa referência e concorda com quem está errado. Se o seu caso não tolera isso, a resposta certa é não usar — e eu digo isso antes de você gastar."
    />
  );
}
